import domain from '@framework/config/domain';
import buildUrl from './helpers/buildUrl';

const staticUrls = {
  getUrl(...uris: (string | string[])[]): string {
    return buildUrl(domain.protocol, domain.finsightDomain, ...uris);
  },

  getContactUsUrl(): string {
    return this.getUrl('/contact-us');
  },

  getTermsOfUseUrl(): string {
    return this.getUrl('/terms-of-use');
  },

  getPrivacyPolicyUrl(): string {
    return this.getUrl('/privacy-policy');
  },
};

export default staticUrls;
